import React from 'react';
import type { Empleado, Sucursal } from '../types';
import { PageShell, glassLight, primaryButton, ghostButton, dangerButton, EmptyState, MotionGrid, MotionItem, T } from '../ui';
export function Empleados({
  emps,
  sucs,
  onNew,
  onEdit,
  onDelete
}: {
  emps: Empleado[];
  sucs: Sucursal[];
  onNew?: () => void;
  onEdit?: (id: string) => void;
  onDelete?: (id: string) => void;
}) {
  return <PageShell title="Empleados" sub={`${emps.length} personas`} action={onNew ? <button onClick={onNew} style={primaryButton} data-id="element-329">
            + Nuevo empleado
          </button> : undefined} data-id="element-328">
      {emps.length === 0 ? <EmptyState title="Sin empleados registrados" hint="Agrega personas y asígnalas a una sucursal." icon={<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" data-id="element-331">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" data-id="element-332" />
              <circle cx="9" cy="7" r="4" data-id="element-333" />
            </svg>} data-id="element-330" /> : <MotionGrid style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill,minmax(260px,1fr))',
      gap: 14
    }} data-id="element-334">
          {emps.map(e => <MotionItem key={e.id} className="getr-card" style={{
        ...glassLight,
        padding: 20
      }} data-id="element-335">
              <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          gap: 12
        }} data-id="element-336">
                <div style={{
            display: 'flex',
            gap: 12,
            alignItems: 'center',
            minWidth: 0
          }} data-id="element-337">
                  <div style={{
              width: 42,
              height: 42,
              borderRadius: '50%',
              flexShrink: 0,
              background: `linear-gradient(135deg, ${T.accent}, #0e9488)`,
              color: '#03201c',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 800,
              fontSize: 16,
              boxShadow: `0 4px 16px ${T.accent}40`
            }} data-id="element-338">
                    {e.nombre.charAt(0).toUpperCase()}
                  </div>
                  <div style={{
              minWidth: 0
            }} data-id="element-339">
                    <div style={{
                fontWeight: 700,
                color: T.text
              }} data-id="element-340">
                      {e.nombre}
                    </div>
                    <div style={{
                fontSize: 12,
                color: T.textSecondary,
                marginTop: 3
              }} data-id="element-341">
                      {e.cargo || 'Sin cargo'}
                    </div>
                    <div style={{
                fontSize: 12,
                color: T.textMuted,
                marginTop: 2
              }} data-id="element-342">
                      {sucs.find(s => s.id === e.sucursalId)?.nombre || 'Sin sucursal'}
                    </div>
                  </div>
                </div>
                {(onEdit || onDelete) && <div style={{
            display: 'flex',
            gap: 8,
            flexShrink: 0
          }} data-id="element-343">
                    {onEdit && <button className="getr-btn-ghost" onClick={() => onEdit(e.id)} style={ghostButton} data-id="element-344">
                        Editar
                      </button>}
                    {onDelete && <button onClick={() => onDelete(e.id)} style={dangerButton} data-id="element-345">
                        Eliminar
                      </button>}
                  </div>}
              </div>
            </MotionItem>)}
        </MotionGrid>}
    </PageShell>;
}